export default __webpack_public_path__ + "static/media/MoreIcon.e13f3594.svg";